"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M16.181 0H7.818a3.307 3.307 0 0 0-3.307 3.307v8.959a2.195 2.195 0 0 0-.728.184c-.222.103-.715.403-.715 1.004v4.253c0 .584.472.891.715 1.005l2.78 1.298.013.006.074.03v1.956A1.999 1.999 0 0 0 8.648 24h6.701a1.999 1.999 0 0 0 2.001-1.998v-1.958l.069-.027.013-.006 2.783-1.291.002-.001c.24-.112.715-.416.715-1.004v-4.26c0-.603-.494-.902-.716-1.005a2.2 2.2 0 0 0-.727-.184V3.307A3.307 3.307 0 0 0 16.18 0Zm-5.4 12.255H5.928v-6.46h12.143v6.46h-4.853V8.268H10.78v3.987Zm0 1.565H4.747a.982.982 0 0 0-.114.006v3.555l2.562 1.198a.77.77 0 0 0 .263.055h9.077a.778.778 0 0 0 .267-.056l2.565-1.19v-3.562a1.127 1.127 0 0 0-.116-.006h-6.033v1.151c0 .701-1.219 1.271-1.219 1.271s-1.218-.57-1.218-1.271v-1.15Zm.497-9.207h-2.2V1.417h2.2v3.196Zm6.793 0h-2.125V1.417h.235a1.89 1.89 0 0 1 1.89 1.89v1.306Zm-3.308-3.196v3.196h-2.302V1.417h2.303Zm-6.868 0v3.196H5.928V3.307a1.89 1.89 0 0 1 1.89-1.89h.077Zm.32 18.782h7.57v1.803a.432.432 0 0 1-.434.433H8.648a.434.434 0 0 1-.434-.433v-1.803Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};